import { createUseStyles } from '../../theme/theming';
const useEmailStyles = createUseStyles((theme) => ({
  wrapper: {
    fontFamily: theme?.typography?.fontFamily,
    width: '100%',
    tableLayout: 'fixed'
  },
  email_description_para: {
    '& p': {
      margin: '0 0 0 !important'
    }
  },
  main: {
    backgroundColor: '#ffffff',
    width: '100%',
    maxWidth: '600px',
    borderSpacing: '0'
  },
  logoimg: {
    width: 'auto',
    height: '48px'
    /* margin: 18px 0px; */
  },
  'p-young-guru-title': {
    fontFamily: theme?.typography?.fontFamily,
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '24px',
    lineHeight: '31px',

    color: '#ffffff',
    marginTop: '18px'
  },
  'p-young-guru-sub-title': {
    fontFamily: theme?.typography?.fontFamily,
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '21px',

    color: '#dbd9d9',
    marginBottom: '18px'
  },
  p: {
    padding: '0',
    margin: '0 !important'
  },

  'two-columns': {
    fontSize: '0',
    textAlign: 'center'
    /* padding:35px 0 40px */
  },
  'two-columns .column': {
    width: '100%',
    maxWidth: '275px',
    display: 'inline-block',
    verticalAlign: 'top'
  },

  'title-lead': {
    fontFamily: theme?.typography?.fontFamily,
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '26px',
    color: '#030a21',
    marginBottom: '5px',
    textAlign: 'left'
  }

  //   @media screen and (max-width: 600px) {
  //   }
}));
export default useEmailStyles;
